import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { InventryFlowReport, InventryFlowReportView } from 'src/app/viewmodels/g-inventory/inventory-flow';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';

@Component({
  selector: 'app-inventory-flow-report',
  templateUrl: './inventory-flow-report.component.html',
  styleUrls: ['./inventory-flow-report.component.scss']
})
export class InventoryFlowReportComponent implements OnInit {
  public InventryFlowReport = new InventryFlowReportView();
  public vmListItems: Array<any> = [];
  public vmListWarehouses: any = [];
  FK_WareHouse_Id = new ItemViewModel1();
  selectedSpareParts: Array<any> = [];
  inventoryFlowList: Array<InventryFlowReportView> = [];
  InCount: number = 0;
  OutCount: number = 0;
  ListCount: number = 0;
  fromDate: any = null;
  toDate: any = null;
  public user: any;
  p = 1; // current page
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    clearSearchFilter: true,
    closeDropDownOnSelection: true
  };
  constructor(private _uow: UnitOfWorkService, private _localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    // this.getSpareParts();
    $('table.display').DataTable();
    this.user = this._localStorageService.get("ussr");
    this.getWarehouse();
  }

  getWarehouse() {
    return new Promise((resolve, reject) => {
      this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
        debugger
        console.log("warehouses", res);
        this.vmListWarehouses = res.result;
        resolve(res);
      });
    });
  }

  getSpareParts() {
    debugger
    if (this.FK_WareHouse_Id !== undefined) {
      this._uow.gSettingService.GetItemsDropDownByWarehouseIdAsync(this.FK_WareHouse_Id.id).subscribe(
        (res: any) => {
          debugger
          this.vmListItems = res.result;
          // if (this.vmListItems.length > 0) {
          //   this.vmListItems.forEach(x => {
          //     x.name = x.code + '-' + x.name;
          //   });
          // }
          console.log(res);
        },
        (err) => {
          this._uow.logger.log(err);
          this.vmListItems = [];
        }
      );
    }
  }
  onItemDeSelect(event) {
    debugger;
    this.selectedSpareParts = [];
  }
  fetchInventoryFlowReport() {
    debugger
    this.spinner.show();
    this._uow.gReportingService.GetInventoryFlowReportAsync(this.selectedSpareParts[0].id, this.FK_WareHouse_Id.id).subscribe((res: any) => {
      console.log('report response', res);
      debugger
      this.inventoryFlowList = res.result;
      if (this.inventoryFlowList.length != 0) {
        this.InCount = this.inventoryFlowList[0].stockInCount;
        this.OutCount = this.inventoryFlowList[0].stockOutCount;
      }
      this.ListCount = this.inventoryFlowList.length;

      this.spinner.hide();
    }, error => {
      console.log(error);
      this.spinner.hide();
    });
  }


  exportToPdf() {
    this.spinner.show();
    debugger;
    // Assuming `toDate` is a JavaScript Date object
    const today = new Date(this.toDate); // Ensure this.toDate is a valid date

    // Format the date as MM-DD-YYYY
    const formattedDate = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;

    const element = document.getElementById('IFReport');

    html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true
    }).then((canvas) => {
      canvas.toBlob((blob) => {
        const imgData = URL.createObjectURL(blob);
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        const ratio = pdfWidth / canvasWidth;
        const pdfCanvasHeight = canvasHeight * ratio;

        let position = 0;
        let pageHeight = pdfHeight;
        let heightLeft = pdfCanvasHeight;

        while (heightLeft > 0) {
          if (position !== 0) {
            pdf.addPage();
          }

          pdf.addImage(
            imgData,
            'PNG',
            0,
            position - (position > 0 ? 5 : 0),
            pdfWidth,
            pdfCanvasHeight
          );
          heightLeft -= pageHeight;
          position -= pageHeight;
        }
        debugger
        var filename = `IFReport_${this.selectedSpareParts[0].Name}_${formattedDate}.pdf`;
        pdf.save(filename);
      }, 'image/jpeg');
    });
    this.spinner.hide();
  }
}
